/** Arabic for engineering and compliance: testing records, capital projects, compliance, equipment modules, the programme, planning and capacity. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  /* ── the capital register, now under Engineering ───────────────────── */
  "← Projects": "← المشاريع",
  "{site} · Engineering": "{site} · الهندسة",
  "The projects shown, as a spreadsheet. Money nobody has declared is left blank, not zero.":
    "المشاريع المعروضة، كجدول بيانات. والمبالغ التي لم يفصح عنها أحد تُترك فارغة، لا أصفاراً.",
  "Source:": "المصدر:",
  "Update test results": "تحديث نتائج الاختبار",
  "Record a test": "تسجيل اختبار",
  "Update {reference} — revision {n}": "تحديث {reference} — المراجعة {n}",
  "The record is kept as revision {n} and marked superseded; this becomes the current record and is judged again. Change what needs correcting and say why.":
    "يُحفظ السجل بوصفه المراجعة {n} ويُعلَّم بأنه مُستبدَل؛ ويصبح هذا السجل الحالي ويُحكم عليه من جديد. غيّر ما يحتاج إلى تصحيح واذكر السبب.",
  "e.g. Contractor re-issued the report; two lights were keyed against the wrong circuit":
    "مثال: أعاد المقاول إصدار التقرير؛ أُدخل مصباحان على دائرة خاطئة",
  "Contractor or team": "المقاول أو الفريق",
  "e.g. RWY 17/35 edge and centerline lights": "مثال: أضواء حافة وخط منتصف RWY 17/35",
  "Upload results file": "رفع ملف النتائج",
  "Recorded as the data source of this record": "مسجَّل بوصفه مصدر بيانات هذا السجل",
  "FROM {file}": "من {file}",
  "Results — one per line: asset tag or location, value, specified value ({unit})":
    "النتائج — نتيجة في كل سطر: رمز الأصل أو الموقع، القيمة، القيمة المحددة ({unit})",
  "Results — one per line: asset tag or location, value ({unit})":
    "النتائج — نتيجة في كل سطر: رمز الأصل أو الموقع، القيمة ({unit})",
  "Paste straight from the contractor's spreadsheet — comma, semicolon or tab separated; a header line is skipped.":
    "الصق مباشرة من جدول المقاول — مفصولة بفاصلة أو فاصلة منقوطة أو مسافة جدولة؛ ويُتجاوز سطر العناوين.",
  "{n} results read.": "قُرئت {n} نتيجة.",
  "and {n} more": "و{n} أخرى",
  "Judged against:": "الحكم وفق:",
  "{label} — attention {attention}, action {fail} % of specified":
    "{label} — انتباه {attention}، إجراء {fail} % من المحدد",
  "{label} — attention {attention}, action {fail}": "{label} — انتباه {attention}، إجراء {fail}",
  "Passes when {value} is at or above {limit}.": "ينجح عندما تكون {value} مساوية لـ {limit} أو أعلى.",
  Pass: "ناجح",
  "Action needed": "يلزم إجراء",
  "This test is judged by the engineer; the verdict needs its basis.":
    "يحكم المهندس على هذا الاختبار؛ ويحتاج الحكم إلى مستنده.",
  "What was found, against which levels, and what follows": "ما الذي وُجد، ووفق أي مستويات، وما الذي يترتب عليه",
  "Blank uses the interval: every {n} days (proposed).": "الترك فارغًا يعتمد الفاصل الزمني: كل {n} يومًا (مقترح).",
  "Blank uses the interval: every {n} days.": "الترك فارغًا يعتمد الفاصل الزمني: كل {n} يومًا.",
  "This test has no interval set.": "لم يُحدَّد فاصل زمني لهذا الاختبار.",
  "Not recorded: {message}": "لم يُسجَّل: {message}",
  "Recorded, but a file did not upload — {error}. Add it from the record.":
    "سُجِّل، لكن ملفًا لم يُرفع — {error}. أضفه من السجل.",
  "Open the record": "فتح السجل",
  "Uploading files…": "جارٍ رفع الملفات…",
  "Save revision {n}": "حفظ المراجعة {n}",
  "Record and judge": "تسجيل وإصدار الحكم",
  "{site} · testing record · {reference} · revision {n}": "{site} · سجل اختبار · {reference} · المراجعة {n}",
  "Correct the results or details as the next revision": "صحّح النتائج أو التفاصيل بوصفها المراجعة التالية",
  "Update results": "تحديث النتائج",
  "← Testing records": "→ سجلات الاختبار",
  "This revision has been superseded.": "استُبدلت هذه المراجعة.",
  "It is kept as it was recorded. The current record is": "وهي محفوظة كما سُجِّلت. السجل الحالي هو",
  "{reference} revision {n}": "{reference} المراجعة {n}",
  "Revision {n}": "المراجعة {n}",
  "Earlier revisions are kept and listed under Revisions below.":
    "المراجعات السابقة محفوظة ومدرجة تحت «المراجعات» أدناه.",
  "Data source": "مصدر البيانات",
  "PROPOSED THRESHOLDS": "حدود مقترحة",
  "DEMONSTRATION DATA": "بيانات عرض توضيحي",
  "Show the {outcome} results": "عرض النتائج: {outcome}",
  "was {n} in {reference}": "كانت {n} في {reference}",
  Test: "الاختبار",
  "Required by": "مطلوب بموجب",
  Performed: "أُجري",
  Device: "الجهاز",
  Method: "الطريقة",
  "Next due": "الاستحقاق التالي",
  "{reference} on {date} — {n} results matched by asset or location":
    "{reference} بتاريخ {date} — {n} نتيجة مطابقة حسب الأصل أو الموقع",
  "Open it →": "فتحه ←",
  "Mean % of specified": "المتوسط % من المحدد",
  Mean: "المتوسط",
  "was {value}": "كانت {value}",
  "Moved down a band": "انخفض نطاقًا",
  "{n} moved up": "{n} ارتفع",
  "Only in this test": "في هذا الاختبار فقط",
  "{n} only in the earlier one": "{n} في الاختبار السابق فقط",
  "{label} action": "{label} إجراء",
  "{label} attention": "{label} انتباه",
  "% of specified": "% من المحدد",
  "Results — {n}": "النتائج — {n}",
  "Asset / location": "الأصل / الموقع",
  Measured: "المقيس",
  Specified: "المحدد",
  Before: "السابق",
  Verdict: "الحكم",
  "(no longer in the register)": "(لم يعد في السجل)",
  "Show the worst 40": "عرض أسوأ 40",
  "Show all {n}": "عرض الكل ({n})",
  "{reference} file {n}": "{reference} ملف {n}",
  file: "ملف",
  "Uploading…": "جارٍ الرفع…",
  "+ Attach files": "+ إرفاق ملفات",
  "{reference} · revision {n}": "{reference} · المراجعة {n}",
  "Data arrived": "وصول البيانات",
  "scripts/seed_demo_tests.py — removable": "scripts/seed_demo_tests.py — قابلة للإزالة",
  Recorded: "سُجِّل",
  "(no person — seeded)": "(دون شخص — بيانات مُدرجة آليًا)",
  Tested: "اختُبر",
  "the engineer who recorded it": "المهندس الذي سجّله",
  "the platform, from each result against the thresholds below": "المنصة، من كل نتيجة مقابل الحدود أدناه",
  "Readings written": "القراءات المكتوبة",
  "so the rules and prediction models see this test": "لكي تطّلع القواعد ونماذج التنبؤ على هذا الاختبار",
  Files: "الملفات",
  "none attached": "لا مرفقات",
  "Thresholds, as they stood when this was recorded": "الحدود كما كانت عند تسجيل هذا",
  "(where {conditions})": "(حيث {conditions})",
  "{field} is {value}": "{field} هو {value}",
  ": attention below {attention}, action below {fail}": ": انتباه دون {attention}، إجراء دون {fail}",
  AGREED: "معتمد",
  "{test} · {reference} rev {n}": "{test} · {reference} مراجعة {n}",
  "device not recorded": "الجهاز غير مسجَّل",
  "entered with the result": "أُدخل مع النتيجة",
  "of specified": "من المحدد",
  "Judged against": "الحكم وفق",
  "agreed threshold": "حد معتمد",
  "proposed threshold": "حد مقترح",
  "No threshold matched this result, so it was not assessed.": "لم يطابق أي حد هذه النتيجة، لذا لم تُقيَّم.",
  "the asset register, as it was when recorded": "سجل الأصول كما كان عند التسجيل",
  "Test before": "الاختبار السابق",
  "{value} in {reference} ({outcome}) · change": "{value} في {reference} ({outcome}) · التغيّر",
  "not in the earlier test": "ليس في الاختبار السابق",
  "{asset} in every {test} test": "{asset} في كل اختبار {test}",
  "No other result for this asset.": "لا توجد نتيجة أخرى لهذا الأصل.",
  "This asset across tests": "هذا الأصل عبر الاختبارات",
  "rev {n}": "مراجعة {n}",
  "Open {title} →": "فتح {title} ←",
  "Log an action": "تسجيل إجراء",
  "Kind of entry": "نوع القيد",
  "Asset tags (optional)": "رموز الأصول (اختياري)",
  "Asset tags": "رموز الأصول",
  "New Work Order from this test; it is logged here": "أمر عمل جديد من هذا الاختبار؛ ويُسجَّل هنا",
  "e.g. Lamps replaced on C5 — AGL-CL-0032, 0033": "مثال: استُبدلت المصابيح على C5 — AGL-CL-0032، 0033",
  "e.g. Re-survey C5 after relamping, week 40": "مثال: إعادة مسح C5 بعد تغيير المصابيح، الأسبوع 40",
  Comment: "تعليق",
  "What was done": "ما الذي أُنجز",
  "Not logged: {message}": "لم يُسجَّل: {message}",
  "Logging…": "جارٍ التسجيل…",
  "Log {kind}": "تسجيل: {kind}",
  Everything: "الكل",
  "Actions taken": "الإجراءات المتخذة",
  "Changes to the record": "التغييرات على السجل",
  "no person (seeded)": "دون شخص (مُدرج آليًا)",
  "Assets:": "الأصول:",
  "Revision {n} (this)": "المراجعة {n} (هذه)",
  original: "الأصلية",
  "{site} · assets & engineering · report": "{site} · الأصول والهندسة · تقرير",
  "{site} · assets & engineering": "{site} · الأصول والهندسة",
  "+ Record a test": "+ تسجيل اختبار",
  "{site} · {name} · generated {date} by {person}": "{site} · {name} · أُنشئ في {date} بواسطة {person}",
  "{n} of these records are demonstration data, marked on every row. They are removed with":
    "{n} من هذه السجلات بيانات عرض توضيحي، ومعلَّمة في كل صف. وتُزال باستخدام",
  "Show the records whose verdict is {outcome}": "عرض السجلات التي حكمها {outcome}",
  "Latest verdict: {outcome}": "آخر حكم: {outcome}",
  "test types whose last test was this — click to list": "أنواع الاختبار التي كان هذا آخر اختبار لها — انقر للعرض",
  "Show the mandatory tests table": "عرض جدول الاختبارات الإلزامية",
  "{n} due within 30 days": "{n} مستحق خلال 30 يومًا",
  "Show the tests never done": "عرض الاختبارات التي لم تُجرَ قط",
  "Never tested": "لم يُختبر قط",
  "of {n} mandatory test types": "من {n} نوع اختبار إلزامي",
  "Clear the filters and show every record": "مسح عوامل التصفية وعرض كل السجلات",
  Records: "السجلات",
  "{files} files · {actions} actions logged": "{files} ملف · {actions} إجراء مسجَّل",
  "Test due": "اختبار مستحق",
  "Last test": "آخر اختبار",
  Interval: "الفاصل الزمني",
  proposed: "مقترح",
  "Engineer's verdict": "حكم المهندس",
  "{label}: attention {attention}, action {fail}": "{label}: انتباه {attention}، إجراء {fail}",
  "PROPOSED thresholds and intervals are reference values with their source shown on hover — not figures from this aerodrome's certification basis. Somebody holding":
    "الحدود والفواصل الزمنية المقترحة قيم مرجعية يظهر مصدرها عند التمرير — وليست أرقامًا من أساس اعتماد هذا المطار. يؤكدها من يملك صلاحية",
  "confirms them; records already judged keep the thresholds they were judged against.":
    "؛ وتحتفظ السجلات التي صدر حكمها بالحدود التي حُكم عليها وفقها.",
  "Search reference, title, provider, scope, method, device, engineering note, finding…":
    "ابحث بالمرجع أو العنوان أو مقدّم الخدمة أو النطاق أو الطريقة أو الجهاز أو الملاحظة الهندسية أو النتيجة…",
  "Service provider": "مقدّم الخدمة",
  "Any service provider": "أي مقدّم خدمة",
  /* the records that name nobody: a result with no one against it cannot be
     queried or repeated later, so it is a thing to be able to look for */
  "No provider recorded ({n})": "بلا مقدّم خدمة مسجّل ({n})",
  "Search tests": "البحث في الاختبارات",
  "Test type": "نوع الاختبار",
  "Any test": "أي اختبار",
  "Any verdict": "أي حكم",
  Framework: "الإطار التنظيمي",
  "Any framework": "أي إطار تنظيمي",
  "Demonstration data": "بيانات عرض توضيحي",
  "Real and demonstration": "الحقيقية والتوضيحية",
  "Real records only": "السجلات الحقيقية فقط",
  "Demonstration only": "التوضيحية فقط",
  By: "بواسطة",
  "Files · actions": "الملفات · الإجراءات",
  "revision {n}": "المراجعة {n}",
  DEMO: "توضيحي",
  "{n} · {fail} action · {attention} attention": "{n} · {fail} إجراء · {attention} انتباه",
  "engineer's verdict": "حكم المهندس",
  summary: "ملخّص",
  "the tenant's test catalog (scripts/seed_test_types.py)":
    "دليل اختبارات الجهة (scripts/seed_test_types.py)",
  "How judged": "طريقة الحكم",
  confirmed: "مؤكَّد",
  "proposed — not yet confirmed": "مقترح — لم يُؤكَّد بعد",
  "every {n} days": "كل {n} يومًا",
  "never tested at this site": "لم يُختبر قط في هذا الموقع",
  Feeds: "يغذّي",
  "results are also written as readings": "تُكتب النتائج أيضًا بوصفها قراءات",
  "the {measurement} measurement, which rules and prediction models read":
    "القياس {measurement} الذي تقرؤه القواعد ونماذج التنبؤ",
  "at or above": "مساوٍ أو أعلى من",
  "Records at this site — {n}": "السجلات في هذا الموقع — {n}",
  "None yet.": "لا شيء بعد.",
  "{fail} action · {attention} attention": "{fail} إجراء · {attention} انتباه",
  "+ Record a {test} test": "+ تسجيل اختبار {test}",
  "Records and revisions": "السجلات والمراجعات",
  "Show more ({n} older)": "عرض المزيد ({n} أقدم)",
  "Distribution of {unit}, {latest} against {prior}": "توزيع {unit}، {latest} مقابل {prior}",
  "Distribution of {unit}, {latest}": "توزيع {unit}، {latest}",
  "Not enough readings to draw a trend.": "لا تكفي القراءات لرسم اتجاه.",
  "Each day": "كل يوم",
  "{unit} per day with {average}": "{unit} يوميًا مع {average}",
  "{unit} per day": "{unit} يوميًا",
  "No meter has readings in both windows, so no change can be worked out.":
    "لا يوجد عداد له قراءات في الفترتين، لذا لا يمكن حساب التغيّر.",
  "Not recorded": "غير مسجَّل",
  "No {test} test has been recorded at this site. Record one under":
    "لم يُسجَّل أي اختبار {test} في هذا الموقع. سجّل اختبارًا في",
  "and it appears here, compared with the test before it.": "وسيظهر هنا مقارنًا بالاختبار الذي سبقه.",
  "{label} action {value}": "{label} إجراء {value}",
  "{label} attention {value}": "{label} انتباه {value}",
  "Open the record →": "فتح السجل ←",
  "Judged against thresholds not yet confirmed against the certification basis":
    "حُكم عليه وفق حدود لم تُؤكَّد بعد مقابل أساس الاعتماد",
  "{n} also in {reference}": "{n} موجودة أيضًا في {reference}",
  "no earlier test to compare": "لا يوجد اختبار سابق للمقارنة",
  "below the action level": "دون مستوى الإجراء",
  "below the attention level": "دون مستوى الانتباه",
  "Mean {unit}": "المتوسط {unit}",
  "was {value} on the same {n}": "كان {value} على الـ {n} نفسها",
  "{n} moved up since {date}": "{n} ارتفع منذ {date}",
  Was: "كان",
  Action: "إجراء",
  Attention: "انتباه",
  "Lowest {n} in this test": "أدنى {n} في هذا الاختبار",
  "Now ({unit})": "الآن ({unit})",
  Change: "التغيّر",
  "{measure}, {n} days with readings": "{measure}، {n} يومًا بقراءات",
  "{unit} since {date}": "{unit} منذ {date}",
  "Average per day": "المتوسط اليومي",
  "Trend over the period": "الاتجاه خلال الفترة",
  "7-day average, first against last": "متوسط 7 أيام، الأول مقابل الأخير",
  "Register resets": "إعادات ضبط العداد",
  "counted as no consumption, not negative": "تُحتسب بلا استهلاك، لا بالسالب",
  "none in the period": "لا شيء خلال الفترة",
  "7-day average": "متوسط 7 أيام",
  "Each meter: last 30 days against the 30 before (per day with readings)":
    "كل عداد: آخر 30 يومًا مقابل الثلاثين السابقة (لكل يوم بقراءات)",
  "{meter}: {recent} {unit} over {recentDays} days, against {previous} over {previousDays} days":
    "{meter}: {recent} {unit} خلال {recentDays} يومًا، مقابل {previous} خلال {previousDays} يومًا",
  Meter: "العداد",
  "Last 30 d": "آخر 30 يومًا",
  "30 d before": "الثلاثون يومًا السابقة",
  "Change / day": "التغيّر / يوم",
  "{value} ({n} d)": "{value} ({n} يوم)",
  "results are read from a .csv or .xlsx file": "تُقرأ النتائج من ملف ‎.csv أو ‎.xlsx",
  "Decide {gate}": "البت في {gate}",
  "Decide gate {n} — {gate}": "البت في البوابة {n} — {gate}",
  "Deciding a gate needs": "البت في بوابة يتطلب",
  ", which is not the permission that updates a project. The decision, its note and anything still missing are written to the audit log.":
    "، وهي ليست الصلاحية التي تحدّث المشروع. ويُكتب القرار وملاحظته وكل ما لا يزال ناقصًا في سجل التدقيق.",
  Decision: "القرار",
  "Evidence this gate asks for": "الأدلة التي تطلبها هذه البوابة",
  "Supplied: {item}": "مُقدَّم: {item}",
  "{n} of {total} required item(s) will not have been supplied: {items}. This gate can still be decided — the platform records that it was, and the record stays on the gate for the life of the project.":
    "لن يكون {n} من {total} بندًا مطلوبًا قد قُدِّم: {items}. لا يزال بالإمكان البت في هذه البوابة — وتسجل المنصة ذلك، ويبقى القيد على البوابة طوال عمر المشروع.",
  "Reason for the waiver": "سبب الإعفاء",
  "e.g. Issued against the standing civils framework": "مثال: صدر بموجب الإطار القائم للأعمال المدنية",
  Optional: "اختياري",
  "Refused: {message}": "مرفوض: {message}",
  "{verb} gate": "{verb} البوابة",
  "This hold point is stopping the work": "نقطة التوقف هذه توقف العمل",
  "Released {date} by {name} — the work may continue past this point.":
    "أُفرج عنها في {date} بواسطة {name} — يمكن أن يستمر العمل بعد هذه النقطة.",
  "Released {date} — the work may continue past this point.":
    "أُفرج عنها في {date} — يمكن أن يستمر العمل بعد هذه النقطة.",
  Witnessed: "الشاهد",
  answered: "مُجاب",
  failed: "راسب",
  "A complete sheet is one where every item was answered, including “not applicable”. It does not mean the inspection passed.":
    "الورقة المكتملة هي التي أُجيب فيها عن كل بند، بما في ذلك «لا ينطبق». ولا يعني ذلك أن الفحص نجح.",
  "This inspection has no items. That is not the same as an inspection on which nothing was found wrong.":
    "لا بنود في هذا الفحص. وهذا لا يعني فحصًا لم يُعثر فيه على أي خلل.",
  Item: "البند",
  "Item {n}": "البند {n}",
  "Defect raised on the register": "سُجِّل عيب في السجل",
  "Needs the project:write permission": "يتطلب صلاحية project:write",
  "{result} item {n}": "{result} البند {n}",
  "Notes — what was found, measured or agreed": "ملاحظات — ما وُجد أو قيس أو اتُّفق عليه",
  "{n} of {total} items are still unchecked, so the platform will refuse “{result}”: an unchecked item is not a pass. Answer them, or record a result that does not assert the work was acceptable.":
    "لا يزال {n} من {total} بندًا دون فحص، لذا سترفض المنصة «{result}»: البند غير المفحوص ليس نجاحًا. أجب عنها، أو سجّل نتيجة لا تؤكد أن العمل مقبول.",
  "Record result": "تسجيل النتيجة",
  "{kind} — this does not stop the work, so it has nothing to release.":
    "{kind} — لا يوقف هذا العمل، لذا لا يوجد ما يُفرج عنه.",
  "Released {date} by {name}.": "أُفرج عنها في {date} بواسطة {name}.",
  "Released {date}.": "أُفرج عنها في {date}.",
  "Note against the release (optional)": "ملاحظة على الإفراج (اختياري)",
  "Release note": "ملاحظة الإفراج",
  "Needs the project:release_hold permission — releasing a hold point is not recording a result":
    "يتطلب صلاحية project:release_hold — الإفراج عن نقطة توقف ليس تسجيلًا لنتيجة",
  "Releasing…": "جارٍ الإفراج…",
  "Release — work may continue": "إفراج — يمكن أن يستمر العمل",
  "Releasing needs": "الإفراج يتطلب",
  ", which this principal does not hold. The platform enforces that; this screen only declines to offer a button that would be refused.":
    "، ولا يملكها هذا المستخدم. تفرض المنصة ذلك؛ وهذه الشاشة تمتنع فقط عن عرض زر سيُرفض.",
  "{site} · capital project · {code}": "{site} · مشروع رأسمالي · {code}",
  "Status, description, money, contractor": "الحالة والوصف والمال والمقاول",
  "Edit details": "تعديل التفاصيل",
  "Current dates and the baseline": "التواريخ الحالية وخط الأساس",
  Schedule: "الجدول الزمني",
  "← Capital projects": "→ المشاريع الرأسمالية",
  "Work stopped — {count}": "العمل متوقف — {count}",
  Baseline: "خط الأساس",
  Current: "الحالي",
  "Baseline was {start} → {end}, moved": "كان خط الأساس {start} ← {end}، ونُقل",
  "at an unrecorded time": "في وقت غير مسجَّل",
  "no reason recorded": "لم يُسجَّل سبب",
  "NOT DECLARED — no budget, commitment or spend has been recorded for this project. That is not a budget of zero.":
    "غير مُعلَن — لم تُسجَّل ميزانية أو التزامات أو إنفاق لهذا المشروع. وهذا لا يعني ميزانية صفرية.",
  Budget: "الميزانية",
  Committed: "الملتزم به",
  Spent: "المصروف",
  Contractor: "المقاول",
  Consultant: "الاستشاري",
  "Gate set": "مجموعة البوابات",
  Relation: "العلاقة",
  affects: "يؤثر في",
  "no gates": "لا بوابات",
  "{decided} of {count} decided · next: {gate}": "بُتّ في {decided} من {count} · التالية: {gate}",
  "{decided} of {count} decided · all decided": "بُتّ في {decided} من {count} · بُتّ في الكل",
  "Decided without the evidence they asked for: {gates}. This is recorded on each gate and stays visible for the life of the project.":
    "بُتّ فيها دون الأدلة التي طلبتها: {gates}. وهذا مسجَّل على كل بوابة ويبقى ظاهرًا طوال عمر المشروع.",
  "due {date}": "تستحق {date}",
  "submitted {date}": "قُدِّمت {date}",
  "decided {date}": "بُتّ فيها {date}",
  "Submit {gate} for decision": "تقديم {gate} للبت",
  "Submit for decision": "تقديم للبت",
  "Needs the project:gate permission — deciding a gate is not writing a project":
    "يتطلب صلاحية project:gate — البت في بوابة ليس تعديلًا للمشروع",
  Decide: "البت",
  "Decide again": "البت مجددًا",
  "No inspection has been recorded against this project. That is not the same as every inspection having passed.":
    "لم يُسجَّل أي فحص لهذا المشروع. وهذا لا يعني أن كل الفحوص نجحت.",
  "{count} · hold points stop the work until released": "{count} · نقاط التوقف توقف العمل حتى يُفرج عنها",
  Sheet: "الورقة",
  State: "الحالة",
  "not inspected": "لم يُفحص",
  "This inspection has no items. That is not an inspection with nothing wrong.":
    "لا بنود في هذا الفحص. وهذا ليس فحصًا خاليًا من الخلل.",
  "no sheet": "لا ورقة",
  "{n} failed": "{n} راسب",
  "released {date} by {name}": "أُفرج عنها {date} بواسطة {name}",
  "released {date}": "أُفرج عنها {date}",
  "{n} unreleased hold point|{n} unreleased hold points":
    "لا نقاط توقف غير مُفرج عنها|نقطة توقف واحدة غير مُفرج عنها|نقطتا توقف غير مُفرج عنهما|{n} نقاط توقف غير مُفرج عنها|{n} نقطة توقف غير مُفرج عنها|{n} نقطة توقف غير مُفرج عنها",
  "{n} record|{n} records": "لا سجلات|سجل واحد|سجلان|{n} سجلات|{n} سجلًا|{n} سجل",
  "{label} ({currency})": "{label} ({currency})",
  "not declared": "غير مُعلَن",
  "New capital project": "مشروع رأسمالي جديد",
  "Choose…": "اختر…",
  "Category default ({gateSet})": "افتراضي الفئة ({gateSet})",
  "Category default": "افتراضي الفئة",
  "{name} — {n} gates": "{name} — {n} بوابة",
  "assigned if blank": "يُعيَّن إن تُرك فارغًا",
  "The baseline is what every slip is measured against. Setting it now is free; moving it later needs a reason, which is recorded.":
    "خط الأساس هو ما يُقاس عليه كل تأخر. تحديده الآن متاح؛ أما نقله لاحقًا فيتطلب سببًا يُسجَّل.",
  "Create project": "إنشاء المشروع",
  "Edit {code}": "تعديل {code}",
  "As declared. No variance or percentage is computed from these.": "كما أُعلن. لا يُحسب منها انحراف أو نسبة مئوية.",
  "Every change is recorded in the audit trail with the value it replaced. Dates are set under Schedule.":
    "يُسجَّل كل تغيير في سجل التدقيق مع القيمة التي حلّ محلها. وتُحدَّد التواريخ من «الجدول الزمني».",
  "Schedule for {code}": "الجدول الزمني لـ {code}",
  "Schedule —": "الجدول الزمني —",
  "e.g. scope added by change order 3": "مثال: نطاق أُضيف بأمر التغيير 3",
  "Saved.": "حُفظ.",
  "Move the baseline": "نقل خط الأساس",
  "Save dates": "حفظ التواريخ",
  "Save {n} change|Save {n} changes":
    "لا تغييرات للحفظ|حفظ تغيير واحد|حفظ تغييرين|حفظ {n} تغييرات|حفظ {n} تغييرًا|حفظ {n} تغيير",
  "Reported {date} by {name}": "أُبلغ عنه {date} بواسطة {name}",
  "Reported {date}": "أُبلغ عنه {date}",
  reported: "مُبلَّغ عنه",
  "Progress reported: {pct}%": "التقدم المُبلَّغ عنه: {pct}%",
  "Reading only — adding to the log needs {permission}.": "قراءة فقط — الإضافة إلى السجل تتطلب {permission}.",
  "Add to the project log": "الإضافة إلى سجل المشروع",
  "What happened — a meeting, a decision, a site observation": "ما الذي حدث — اجتماع أو قرار أو ملاحظة ميدانية",
  "Progress this period": "التقدم في هذه الفترة",
  "What needs doing": "ما الذي يلزم إنجازه",
  "Entry text": "نص القيد",
  "% complete (optional)": "% الإنجاز (اختياري)",
  "Percent complete": "نسبة الإنجاز",
  "Owner (required)": "المسؤول (مطلوب)",
  "Due date": "تاريخ الاستحقاق",
  "Record {kind}": "تسجيل: {kind}",
  OPEN: "مفتوح",
  DONE: "منجز",
  CANCELLED: "ملغى",
  unrecorded: "غير مسجَّل",
  "no due date": "بلا تاريخ استحقاق",
  "{status} {date}": "{status} {date}",
  "Why it is being canceled (required)": "سبب الإلغاء (مطلوب)",
  "Cancellation note": "ملاحظة الإلغاء",
  "Cancel action": "إلغاء الإجراء",
  "Mark done": "تعليم كمنجز",
  "Cancel…": "إلغاء…",
  "open action|open actions": "إجراءات مفتوحة|إجراء مفتوح|إجراءان مفتوحان|إجراءات مفتوحة|إجراءً مفتوحًا|إجراء مفتوح",
  "{site} · capital projects": "{site} · المشاريع الرأسمالية",
  "Any category": "أي فئة",
  "Live only": "القائمة فقط",
  "+ New project": "+ مشروع جديد",
  "No projects match at {site}. That is not the same as none existing — clear the filters to see the whole portfolio.":
    "لا مشاريع مطابقة في {site}. وهذا لا يعني عدم وجود مشاريع — امسح عوامل التصفية لعرض المحفظة كاملة.",
  Gates: "البوابات",
  Holding: "التوقف",
  End: "النهاية",
  "This project has no gates at all, which is not the same as having passed them.":
    "لا بوابات لهذا المشروع إطلاقًا، وهذا لا يعني أنه اجتازها.",
  "No budget has been declared for this project.": "لم تُعلَن ميزانية لهذا المشروع.",
  "NOT DECLARED": "غير مُعلَن",
  "{n}d over": "متجاوز بـ {n} يوم",
  "Nothing in “{list}”.": "لا شيء في «{list}».",
  Gate: "البوابة",
  Detail: "التفاصيل",
  "Why it is here": "سبب وجوده هنا",
  "unreleased hold point": "نقطة توقف غير مُفرج عنها",
  submitted: "مُقدَّمة",
  "due {date} — overdue": "تستحق {date} — متأخرة",
  "decided with required evidence never supplied; recorded on the gate for the life of the project":
    "بُتّ فيها دون تقديم الأدلة المطلوبة؛ ومسجَّل على البوابة طوال عمر المشروع",
  "recorded as '{result}' with {n} of {total} items unchecked":
    "سُجِّلت بوصفها '{result}' مع {n} من {total} بندًا دون فحص",
  "{days} past the current end date of {date}": "{days} بعد تاريخ النهاية الحالي {date}",
  "{days} later than the baseline of {date}": "{days} بعد خط الأساس {date}",
  "live with no baseline, so nothing here can say whether it is late":
    "قائم بلا خط أساس، لذا لا شيء هنا يستطيع أن يحدد إن كان متأخرًا",
  "{status} with no inspection recorded at all": "{status} دون أي فحص مسجَّل إطلاقًا",
  "{n} hold point unreleased — work is stopped|{n} hold points unreleased — work is stopped":
    "لا نقاط توقف غير مُفرج عنها|نقطة توقف واحدة غير مُفرج عنها — العمل متوقف|نقطتا توقف غير مُفرج عنهما — العمل متوقف|{n} نقاط توقف غير مُفرج عنها — العمل متوقف|{n} نقطة توقف غير مُفرج عنها — العمل متوقف|{n} نقطة توقف غير مُفرج عنها — العمل متوقف",
  "{n} project|{n} projects": "لا مشاريع|مشروع واحد|مشروعان|{n} مشاريع|{n} مشروعًا|{n} مشروع",
  "submitted {n} day ago|submitted {n} days ago":
    "قُدِّمت اليوم|قُدِّمت قبل يوم واحد|قُدِّمت قبل يومين|قُدِّمت قبل {n} أيام|قُدِّمت قبل {n} يومًا|قُدِّمت قبل {n} يوم",
  "{n} day|{n} days": "{n} يوم|يوم واحد|يومان|{n} أيام|{n} يومًا|{n} يوم",
  "{site} · compliance": "{site} · الامتثال",
  "No obligations at {site} yet. The packs materialise them when the insight engine runs.":
    "لا التزامات في {site} بعد. تُنشئها الحزم عند تشغيل محرك التحليل.",
  "{n} open · every period is listed whether or not it was met, so what is missing shows":
    "{n} مفتوح · تُدرج كل فترة سواء استُوفيت أم لا، ليظهر ما هو ناقص",
  Obligation: "الالتزام",
  Period: "الفترة",
  "{met} of {total} met": "استُوفي {met} من {total}",
  "{n} overdue": "{n} متأخر",
  "on {trigger}": "عند {trigger}",
  "Pack default: {value}": "افتراضي الحزمة: {value}",
  "Gated — {reason}.": "معلّقة على التحقق — {reason}.",
  disabled: "معطّلة",
  "Thresholds confirmed against {basis} on {date}.": "الحدود مؤكَّدة مقابل {basis} في {date}.",
  "Thresholds confirmed against {basis}.": "الحدود مؤكَّدة مقابل {basis}.",
  Live: "مفعّلة",
  Gated: "معلّقة على التحقق",
  "Needs the rule:verify permission": "يتطلب صلاحية rule:verify",
  "Re-confirm {rule}": "إعادة تأكيد {rule}",
  "Verify and enable {rule}": "التحقق من {rule} وتفعيلها",
  "Re-confirm": "إعادة التأكيد",
  "Verify and enable": "التحقق والتفعيل",
  "Verify {rule}": "التحقق من {rule}",
  "Re-confirm — {rule}": "إعادة التأكيد — {rule}",
  "Verify and enable — {rule}": "التحقق والتفعيل — {rule}",
  "No reference cited by the pack.": "لم تستشهد الحزمة بمرجع.",
  "This confirmation applies to this tenant only; the pack's defaults are unchanged and a pack upgrade cannot revert it.":
    "ينطبق هذا التأكيد على هذه الجهة فقط؛ وتبقى افتراضيات الحزمة دون تغيير ولا يستطيع تحديث الحزمة التراجع عنه.",
  "{key} — pack default {value}": "{key} — افتراضي الحزمة {value}",
  "This rule has no parameters; verification records the basis only.":
    "لا معاملات لهذه القاعدة؛ ويسجّل التحقق المستند فقط.",
  "e.g. Aerodrome Manual Part D §3.4 (GACAR 139.327), issue 9":
    "مثال: دليل المطار الجزء D ‏§3.4 (GACAR 139.327)، الإصدار 9",
  "Confirmed against": "مؤكَّد مقابل",
  "Re-confirm thresholds": "إعادة تأكيد الحدود",
  "Confirm and enable": "التأكيد والتفعيل",
  "{site} · airfield · report": "{site} · الجانب الجوي · تقرير",
  "{title} — report": "{title} — تقرير",
  "Back to the module": "العودة إلى الوحدة",
  "Assets registered": "الأصول المسجَّلة",
  "{n} asset types": "{n} نوع أصل",
  "Without an open defect": "دون عيب مفتوح",
  "{n} asset carries one": "{n} أصل يحمل عيبًا",
  "{n} assets carry one": "{n} أصول تحمل عيبًا",
  "Open defects": "العيوب المفتوحة",
  "{raised} raised · {resolved} resolved in 30 days": "{raised} مُسجَّل · {resolved} مُعالَج خلال 30 يومًا",
  "Severity 4–5 open": "مفتوحة بخطورة 4–5",
  "{overdue} overdue · {breached} SLA breached": "{overdue} متأخر · {breached} تجاوز SLA",
  "Assets with readings": "أصول لها قراءات",
  "{pct} of the register": "{pct} من السجل",
  "Condition scored": "مُقيَّم الحالة",
  "assets with a condition score": "أصول لها درجة حالة",
  "no condition score recorded — not zero": "لا درجة حالة مسجَّلة — وليست صفرًا",
  "Inspection rounds": "جولات التفتيش",
  "{n} done": "{n} منجزة",
  "{n} scheduled · last {date}": "{n} مجدولة · الأخيرة {date}",
  "{label} ≥ 80%": "{label} ≥ 80%",
  "{over} past rated · of {judged} with a rating": "{over} تجاوز المقنَّن · من {judged} لها تقنين",
  "Not declared by the installed packs: {types}. Nothing of that type can be shown.":
    "غير مُعرَّف في الحزم المثبتة: {types}. لا يمكن عرض شيء من هذا النوع.",
  "Not in the register: {types}. No asset of these types is declared, so they are listed nowhere here — that is not the same as none being fitted.":
    "ليست في السجل: {types}. لا أصول مُعرَّفة من هذه الأنواع، لذا لا تُدرج في أي مكان هنا — وهذا لا يعني عدم تركيب أي منها.",
  "Asset type": "نوع الأصل",
  Located: "محدد الموقع",
  "With an open defect": "بعيب مفتوح",
  "Without one": "دون عيب",
  "{type} by {attribute}": "{type} حسب {attribute}",
  "… {n} more values": "… {n} قيمة أخرى",
  "{n} open on {assets} assets": "{n} مفتوح على {assets} أصل",
  Sev: "الخطورة",
  Detected: "تاريخ الاكتشاف",
  "… and {n} more not listed.": "… و{n} أخرى غير مدرجة.",
  "Open in Work orders →": "فتح في أوامر العمل ←",
  Measurement: "القياس",
  Readings: "القراءات",
  First: "الأولى",
  Latest: "الأحدث",
  "hours run against hours rated, where both are recorded — {judged} judged, {unrated} with readings but no rating":
    "ساعات التشغيل مقابل الساعات المقنَّنة، حيث تُسجَّل كلتاهما — {judged} مُقيَّم، {unrated} بقراءات دون تقنين",
  "Hours run": "ساعات التشغيل",
  Rated: "المقنَّن",
  "Life used": "العمر المستهلك",
  Read: "القراءة",
  "{label}: {count} of {total}": "{label}: {count} من {total}",
  "Add an engineer note": "إضافة ملاحظة مهندس",
  "Note category": "فئة الملاحظة",
  "Asset tag": "رمز الأصل",
  "e.g. Circuit C4 trips after heavy rain — megger the feeder before the next night round.":
    "مثال: تفصل الدائرة C4 بعد الأمطار الغزيرة — افحص عزل المغذي قبل الجولة الليلية التالية.",
  "Not saved: {message}": "لم يُحفظ: {message}",
  "Add note": "إضافة ملاحظة",
  "Reading only — writing a note needs {permission}.": "قراءة فقط — كتابة ملاحظة تتطلب {permission}.",
  "No record for this candidate.": "لا سجل لهذا المرشح.",
  "Would strengthen it:": "ما يعززه:",
  "{date} — {n} days ago": "{date} — قبل {n} يوم",
  "{scheduled} scheduled · {deferred} deferred · {undecided} undecided":
    "{scheduled} مجدول · {deferred} مؤجل · {undecided} دون قرار",
  "of work is already priced and funded, and is held up by a missing fact rather than by money, weather or traffic. Every one of those is listed below with the single thing that would release it.":
    "من الأعمال مسعَّرة وممولة بالفعل، وتعطّلها معلومة ناقصة لا المال ولا الطقس ولا الحركة. وكل واحد منها مدرج أدناه مع الأمر الوحيد الذي يطلقه.",
  "of work is scheduled, and every candidate on the register reached a decision.":
    "من الأعمال مجدولة، وقد وصل كل مرشح في السجل إلى قرار.",
  Envelope: "سقف الميزانية",
  "Escalation if deferred": "تصاعد التكلفة عند التأجيل",
  "Register decided": "نسبة ما بُتّ فيه",
  "Scheduled — {n}": "مجدول — {n}",
  "avoids {amount} of escalation": "يتجنب {amount} من تصاعد التكلفة",
  "Weather from {sources}.": "الطقس من {sources}.",
  "Deferred — {n}": "مؤجل — {n}",
  "+{amount} if it waits": "+{amount} إن انتظر",
  "Could not be decided — {n}": "تعذّر البت — {n}",
  "{amount} of funded work": "{amount} من الأعمال الممولة",
  "Unblocks:": "يطلق:",
  "Searched {from} to {to}.": "البحث من {from} إلى {to}.",
  "Hide the evidence": "إخفاء الأدلة",
  "Why this?": "لماذا هذا؟",
  "{n} candidate unrankable|{n} candidates unrankable":
    "لا مرشحين|مرشح واحد يتعذر ترتيبه|مرشحان يتعذر ترتيبهما|{n} مرشحين يتعذر ترتيبهم|{n} مرشحًا يتعذر ترتيبهم|{n} مرشح يتعذر ترتيبهم",
  "e.g. A12": "مثال: A12",
  "Hours needed": "الساعات المطلوبة",
  "Search from": "البحث من",
  "Search to": "البحث إلى",
  "Find a window": "إيجاد نافذة",
  "This needs both": "يتطلب هذا كلتا الصلاحيتين",
  and: "و",
  ". The platform requires both deliberately — a joint verdict is only as trustworthy as its weaker half.":
    ". تشترط المنصة كلتيهما عمدًا — فالحكم المشترك لا يزيد موثوقية عن نصفه الأضعف.",
  "Name a position, the work and how long it takes. The answer is the hours to book a crew for — or why there are none.":
    "حدّد الموقع والعمل والمدة التي يستغرقها. الجواب هو الساعات التي يُحجز لها الطاقم — أو سبب عدم وجودها.",
  "Do it": "نفّذه",
  "Clear of traffic and within the weather limits for “{category}”.": "خالٍ من الحركة وضمن حدود الطقس لـ «{category}».",
  "{n} windows qualify; this is the earliest.": "{n} نافذة مؤهلة؛ وهذه أقربها.",
  "This is not a plan — half of it could not be checked": "هذه ليست خطة — تعذّر التحقق من نصفها",
  "Both constraints are clear at different times, and never together":
    "القيدان متاحان في أوقات مختلفة، ولا يجتمعان أبدًا",
  "No window — {a} and {b}": "لا نافذة — {a} و{b}",
  "No window — {a}": "لا نافذة — {a}",
  "No window": "لا نافذة",
  Traffic: "الحركة",
  "Can the position be closed without stranding an aircraft": "هل يمكن إغلاق الموقع دون ترك طائرة عالقة",
  Weather: "الطقس",
  "Can the work physically and legally be done": "هل يمكن تنفيذ العمل فعليًا ونظاميًا",
  "{n} h": "{n} س",
  "Assessed from {sources}.": "قُيِّم من {sources}.",
  "Cost this closure": "احسب تكلفة هذا الإغلاق",
  "Name a position and a window. The answer is a disposition, not a count — and only the last number in it is worth an argument.":
    "حدّد موقعًا ونافذة زمنية. الجواب توزيع لا عدد — والرقم الأخير فيه وحده يستحق النقاش.",
  "with nowhere to go": "بلا مكان تذهب إليه",
  "This closure cannot be costed": "يتعذّر حساب تكلفة هذا الإغلاق",
  Size: "الحجم",
  "Would move to": "ستنتقل إلى",
  Why: "السبب",
  nowhere: "لا مكان",
  "Cannot be closed — {n}": "لا يمكن إغلاقها — {n}",
  Stranded: "العالقة",
  "Can be closed — {n}": "يمكن إغلاقها — {n}",
  "Cost of closing": "تكلفة الإغلاق",
  "{n} bussed": "{n} بالحافلات",
  "absorbed entirely": "استُوعبت بالكامل",
  "movement, all placed|movements, all placed":
    "حركة، وُزّعت كلها|حركة، وُزّعت|حركتان، وُزّعتا كلتاهما|حركات، وُزّعت كلها|حركة، وُزّعت كلها|حركة، وُزّعت كلها",
  "The schedule does not cover this window.": "الجدول لا يغطي هذه النافذة.",
  "{n} absorbed": "{n} مستوعَبة",
  "{n} undetermined": "{n} غير محددة",
  "{n} with nowhere to go": "{n} بلا مكان تذهب إليه",
  "{movements} in the window: {parts}.": "{movements} في النافذة: {parts}.",
  "{n} movement|{n} movements": "لا حركات|حركة واحدة|حركتان|{n} حركات|{n} حركة|{n} حركة",
  "This is a {kind}, which does not stop the work and so has nothing to release.":
    "هذا {kind}، ولا يوقف العمل، لذا لا يوجد ما يُفرج عنه.",
  "This hold point has already been released.": "أُفرج عن نقطة التوقف هذه بالفعل.",
  "No result has been recorded, so nothing has been inspected. Releasing it would be a signature against a check that never happened.":
    "لم تُسجَّل نتيجة، لذا لم يُفحص شيء. والإفراج عنها سيكون توقيعًا على فحص لم يحدث.",
  "The inspection failed. A failed hold point is cleared by re-inspecting the work — raise a re-inspection and release that.":
    "رسب الفحص. تُرفع نقطة التوقف الراسبة بإعادة فحص العمل — أنشئ إعادة فحص وأفرج عنها.",
  "{n} of {total} items are unchecked. Releasing past an unfinished sheet is what the hold point was placed to prevent.":
    "{n} من {total} بندًا دون فحص. والإفراج مع ورقة غير مكتملة هو ما وُضعت نقطة التوقف لمنعه.",
  "{amount} {currency} (minor units)": "{amount} {currency} (وحدات فرعية)",
  "Recorded {reference} — {outcome}": "سُجِّل {reference} — {outcome}",
  ", {n} results": "، {n} نتيجة",
  "from {file}": "من {file}",
  "(demonstration data)": "(بيانات عرض توضيحي)",
  "Revision {n}: {before} → {after}. Reason: {reason}": "المراجعة {n}: {before} ← {after}. السبب: {reason}",
  "Attached {name}": "أُرفق {name}",
  "a file": "ملف",
  "Thresholds for {test} set — {basis}": "حُدِّدت حدود {test} — {basis}",
  "line {n}: expected “asset or location, value”, got “{text}”":
    "السطر {n}: المتوقع «أصل أو موقع، قيمة»، والوارد «{text}»",
  "line {n}: the specified value “{value}” is not a positive number":
    "السطر {n}: القيمة المحددة «{value}» ليست رقمًا موجبًا",
  "Due {due}; not tested since {last}.": "مستحق {due}؛ لم يُختبر منذ {last}.",
  "No test of this type has been recorded at this site.": "لم يُسجَّل أي اختبار من هذا النوع في هذا الموقع.",
  "Reason for the update (required, recorded)": "سبب التحديث (مطلوب، ويُسجَّل)",
  "Performed on": "تاريخ الإجراء",
  "Performed by": "أجراه",
  "Device / equipment": "الجهاز / المعدة",
  "Method / standard followed": "الطريقة / المعيار المتبع",
  "Title (optional)": "العنوان (اختياري)",
  "Basis for the verdict (required)": "مستند الحكم (مطلوب)",
  "Next test due (optional)": "موعد الاختبار التالي (اختياري)",
  "Test report and data files (PDF, image, CSV or Excel, up to 25 MB each)":
    "تقرير الاختبار وملفات البيانات (PDF أو صورة أو CSV أو Excel، حتى 25 MB لكل ملف)",
  "the engineer's verdict, with its basis": "حكم المهندس مع مستنده",
  "worked out by the platform from the results and thresholds below": "استخلصته المنصة من النتائج والحدود أدناه",
  "Against the test before": "مقارنة بالاختبار السابق",
  "worst first · click a result for its detail, its source and its history across tests":
    "الأسوأ أولًا · انقر نتيجة لعرض تفاصيلها ومصدرها وتاريخها عبر الاختبارات",
  "test reports and data as supplied, from every revision of this record":
    "تقارير الاختبار والبيانات كما قُدِّمت، من كل مراجعات هذا السجل",
  "No file is attached to this record.": "لا ملف مرفق بهذا السجل.",
  "Actions & activity": "الإجراءات والنشاط",
  "what was done about this test, and every change to the record — permanent, with who and when":
    "ما اتُّخذ بشأن هذا الاختبار، وكل تغيير على السجل — دائم، مع من ومتى",
  "Nothing logged yet.": "لم يُسجَّل شيء بعد.",
  "from Testing records": "من سجلات الاختبار",
  "Group by": "التجميع حسب",
  "Consumption and trend": "الاستهلاك والاتجاه",
  "No meter on this equipment has register readings in the period, so there is no consumption to chart.":
    "لا يوجد عداد في هذه المعدات له قراءات خلال الفترة، لذا لا يوجد استهلاك لرسمه.",
  "from the meters' own registers — the rise between readings, a period with no reading left out rather than counted as zero":
    "من سجلات العدادات نفسها — الارتفاع بين القراءات، وتُستبعد الفترة التي لا قراءة فيها بدل احتسابها صفرًا",
  Measure: "المقياس",
  "180 days": "180 يومًا",
  Electricity: "الكهرباء",
  Water: "المياه",
  "On-site generation": "التوليد في الموقع",
  "Testing records — report": "سجلات الاختبار — تقرير",
  "No test types are declared for this tenant, so there is nothing to record against yet.":
    "لا أنواع اختبار مُعرَّفة لهذه الجهة، لذا لا يوجد ما يُسجَّل مقابله بعد.",
  "Needs attention or action": "يحتاج إلى انتباه أو إجراء",
  "the latest test of each type that did not pass, and every test that is late or has never been done":
    "أحدث اختبار من كل نوع لم ينجح، وكل اختبار متأخر أو لم يُجرَ قط",
  "Every test type's latest test passed and none is overdue.": "نجح أحدث اختبار لكل نوع ولا يوجد متأخر.",
  "Mandatory tests": "الاختبارات الإلزامية",
  "each test type, the documents that require it, its last result and when the next is due — click a test for its detail and data source":
    "كل نوع اختبار، والوثائق التي تتطلبه، وآخر نتيجة له وموعد الاختبار التالي — انقر اختبارًا لعرض تفاصيله ومصدر بياناته",
  "Test register": "سجل الاختبارات",
  "every test recorded at this site, newest first — current revisions; click a record to open it":
    "كل اختبار مسجَّل في هذا الموقع، الأحدث أولًا — المراجعات الحالية؛ انقر سجلًا لفتحه",
  "No test matches these filters.": "لا اختبار يطابق عوامل التصفية هذه.",
  "No test has been recorded at this site yet.": "لم يُسجَّل أي اختبار في هذا الموقع بعد.",
  "Activity log": "سجل النشاط",
  "everything done in Testing records at this site — recorded, revised, files attached, actions taken — with who and when":
    "كل ما أُنجز في سجلات الاختبار في هذا الموقع — تسجيل ومراجعة وإرفاق ملفات واتخاذ إجراءات — مع من ومتى",
  "Nothing logged.": "لم يُسجَّل شيء.",
  "Each result is judged against the threshold its attributes select; the record is as bad as its worst result.":
    "يُحكم على كل نتيجة وفق الحد الذي تحدده سماتها؛ ويُقيَّم السجل بأسوأ نتائجه.",
  "A summary figure is judged against the limit it must meet.": "يُحكم على رقم ملخّص وفق الحد الذي يجب أن يستوفيه.",
  "The engineer gives the verdict, and must record its basis.": "يُصدر المهندس الحكم، ويجب أن يسجّل مستنده.",
  "Reason for the waiver (required) — a waiver with no reason reads afterwards as a gate that never applied":
    "سبب الإعفاء (مطلوب) — الإعفاء بلا سبب يُقرأ لاحقًا كبوابة لم تنطبق قط",
  Items: "البنود",
  "the sheet is frozen: changing answers now would rewrite the sheet the release was given against":
    "الورقة مجمّدة: تغيير الإجابات الآن سيعيد كتابة الورقة التي صدر الإفراج بناءً عليها",
  "an unchecked item is not a pass": "البند غير المفحوص ليس نجاحًا",
  "Record the result": "تسجيل النتيجة",
  "what the inspection found. This does not release a hold point.": "ما وجده الفحص. وهذا لا يُفرج عن نقطة توقف.",
  "Release the hold point": "الإفراج عن نقطة التوقف",
  "a separate act, separately permissioned and audited every time — this is the signature the hold point was placed to require":
    "إجراء مستقل، بصلاحية مستقلة ويُدقَّق في كل مرة — هذا هو التوقيع الذي وُضعت نقطة التوقف لاشتراطه",
  "no items": "لا بنود",
  "not started": "لم يبدأ",
  incomplete: "غير مكتملة",
  Money: "المال",
  "as declared — the platform computes nothing from these and neither does this screen":
    "كما أُعلن — لا تحسب المنصة منها شيئًا ولا هذه الشاشة",
  "What this project touches": "ما يمسّه هذا المشروع",
  "recorded so the project is findable from the thing it affects": "مسجَّل ليمكن الوصول إلى المشروع مما يؤثر فيه",
  "Stage gates": "بوابات المراحل",
  "Code (optional)": "الرمز (اختياري)",
  "Baseline start": "بداية خط الأساس",
  "Baseline end": "نهاية خط الأساس",
  "Reason for moving the baseline (required, recorded)": "سبب نقل خط الأساس (مطلوب، ويُسجَّل)",
  "Project log": "سجل المشروع",
  "notes, progress updates and actions — permanent once recorded; actions close as done or cancelled":
    "ملاحظات وتحديثات تقدم وإجراءات — دائمة بعد تسجيلها؛ وتُغلق الإجراءات بوصفها منجزة أو ملغاة",
  Updates: "التحديثات",
  Actions: "الإجراءات",
  "Open actions": "الإجراءات المفتوحة",
  "Entry kind": "نوع القيد",
  "Nothing of that kind yet.": "لا شيء من هذا النوع بعد.",
  "Nothing recorded on this project yet.": "لم يُسجَّل شيء على هذا المشروع بعد.",
  "each list is a different failure with a different fix": "كل قائمة خلل مختلف بعلاج مختلف",
  Portfolio: "المحفظة",
  "stopped work first, then late, then the rest — not by value: a stopped project stops the same way whatever it cost":
    "العمل المتوقف أولًا، ثم المتأخر، ثم البقية — لا حسب القيمة: المشروع المتوقف يتوقف بالطريقة نفسها أيًا كانت تكلفته",
  Obligations: "الالتزامات",
  Rules: "القواعد",
  "No obligations match.": "لا التزامات مطابقة.",
  "as this tenant runs them — a gated rule produces no alerts until its thresholds are confirmed against the certification basis":
    "كما تشغّلها هذه الجهة — القاعدة المعلّقة على التحقق لا تُصدر تنبيهات حتى تُؤكَّد حدودها مقابل أساس الاعتماد",
  "All frameworks": "كل الأطر التنظيمية",
  "Confirmed against (required) — the certification basis, an AIP entry, a calibration certificate":
    "مؤكَّد مقابل (مطلوب) — أساس الاعتماد، أو قيد في AIP، أو شهادة معايرة",
  "Platform KPIs": "مؤشرات الأداء الرئيسية في المنصة",
  "as the platform computes and grades them": "كما تحسبها المنصة وتقدّرها",
  "what is recorded, by asset type — and how much of it is not": "ما هو مسجَّل حسب نوع الأصل — وكم منه غير مسجَّل",
  "No asset of these types is registered at this site.": "لا أصل من هذه الأنواع مسجَّل في هذا الموقع.",
  "No open defect on this equipment.": "لا عيب مفتوح في هذه المعدات.",
  "raised against this equipment, traced through the defect or alert that raised them":
    "الصادرة لهذه المعدات، متتبَّعة عبر العيب أو التنبيه الذي أصدرها",
  "No work order has been raised against this equipment.": "لم يصدر أي أمر عمل لهذه المعدات.",
  "what is measured on this equipment, and how recently": "ما يُقاس في هذه المعدات، ومدى حداثته",
  "No reading is recorded against this equipment.": "لا قراءة مسجَّلة لهذه المعدات.",
  "No asset records both its hours and its rating, so no life can be worked out.":
    "لا يسجّل أي أصل ساعاته وتقنينه معًا، لذا لا يمكن حساب العمر.",
  "what the rules have raised on this equipment": "ما أصدرته القواعد على هذه المعدات",
  "Engineer notes": "ملاحظات المهندسين",
  "what engineers know about this equipment — permanent once written; a correction is a new note":
    "ما يعرفه المهندسون عن هذه المعدات — دائم بعد كتابته؛ والتصحيح ملاحظة جديدة",
  "No engineer has written a note on this equipment yet.": "لم يكتب أي مهندس ملاحظة على هذه المعدات بعد.",
  "Surface markings and vertical signs — retro-reflectivity against the last survey, the register, what is wrong, the work raised, and engineers' notes.":
    "العلامات الأرضية واللوحات الإرشادية الرأسية — الانعكاس الارتدادي مقابل آخر مسح، والسجل، وما فيه خلل، والأعمال الصادرة، وملاحظات المهندسين.",
  "Airfield ground lighting and its series circuits — photometric results against the last survey, lamp life against rated hours, night rounds, and navigational aids where registered.":
    "الإنارة الأرضية للمطار (AGL) ودوائرها المتسلسلة — النتائج الضوئية مقابل آخر مسح، وعمر المصابيح مقابل الساعات المقنَّنة، والجولات الليلية، والمساعدات الملاحية حيث تكون مسجَّلة.",
  "Metering, generation and drainage — consumption trends and period comparisons, meters not reporting, verification rounds and engineers' notes.":
    "القياس والتوليد والتصريف — اتجاهات الاستهلاك ومقارنات الفترات، والعدادات التي لا ترسل قراءات، وجولات التحقق، وملاحظات المهندسين.",
  "Retro-reflectivity": "الانعكاس الارتدادي",
  "Photometric testing": "الاختبار الضوئي",
  Colour: "اللون",
  "Marking type": "نوع العلامة",
  Illuminated: "مضاءة",
  Legend: "النص",
  "Light type": "نوع الضوء",
  Circuit: "الدائرة",
  Mounting: "التركيب",
  "Lamp type": "نوع المصباح",
  "Circuit number": "رقم الدائرة",
  "Meter role": "دور العداد",
  Serves: "يخدم",
  "Structure type": "نوع المنشأة",
  "Lamp life": "عمر المصباح",
  "ILS localizer": "مُحدِّد اتجاه ILS",
  "ILS glide path": "مسار انحدار ILS",
  Observation: "ملاحظة ميدانية",
  Recommendation: "توصية",
  Handover: "تسليم",
  "Follow-up": "متابعة",
  "% of specified intensity": "% من الشدة المحددة",
  "No programme could be built for this year.": "تعذّر بناء برنامج لهذه السنة.",
  "Decided, and the decision was to wait. The cost of waiting is stated on each.":
    "بُتّ فيها، وكان القرار الانتظار. وتكلفة الانتظار مذكورة على كل منها.",
  "Grouped by who supplies the missing fact. Each row names one thing, and what it would release.":
    "مجمّعة حسب من يوفّر المعلومة الناقصة. كل صف يسمّي أمرًا واحدًا، وما الذي سيطلقه.",
  Observed: "مُشاهَد",
  "Derived from a model": "مُستنتَج من نموذج",
  "Asserted by a party": "مُصرَّح به من طرف",
  "Nothing behind this": "لا شيء يسنده",
  "When to do the work": "متى يُنفَّذ العمل",
  "The job": "المهمة",
  "Traffic and weather are answered separately and joined here. Both must be answerable, or there is no plan.":
    "يُجاب عن الحركة والطقس كلٌّ على حدة ويُجمعان هنا. ويجب أن يكون الجواب عن كليهما ممكنًا، وإلا فلا خطة.",
  "What each half said": "ما قاله كل نصف",
  "The join is only as good as its weaker side, so both are shown.":
    "الجمع لا يزيد جودة عن جانبه الأضعف، لذا يُعرض الجانبان.",
  "Window found": "وُجدت نافذة",
  "Cannot be assessed": "يتعذّر التقييم",
  traffic: "الحركة",
  weather: "الطقس",
  "What closing a stand costs": "تكلفة إغلاق موقف طائرة",
  "One position": "موقع واحد",
  "Which cannot close": "ما لا يمكن إغلاقه",
  "The window": "النافذة الزمنية",
  "The cost of a closure is the traffic that has nowhere else to go — not the traffic it carries.":
    "تكلفة الإغلاق هي الحركة التي لا مكان آخر لها — لا الحركة التي يستوعبها الموقع.",
  "Where each movement would go": "إلى أين ستذهب كل حركة",
  "The reason is the answer; the destination is a consequence of it.": "السبب هو الجواب؛ والوجهة نتيجة له.",
  "Closing one of these strands traffic. They are not necessarily the busiest stands.":
    "إغلاق أيٍّ منها يترك حركة عالقة. وليست بالضرورة أكثر المواقف ازدحامًا.",
  "Nothing on this estate is a single point of failure in this window.":
    "لا شيء في هذا المرفق نقطة إخفاق وحيدة في هذه النافذة.",
  "This is where maintenance should go first, and the list is usually longer than operators expect.":
    "هنا ينبغي أن تبدأ الصيانة، والقائمة عادةً أطول مما يتوقعه المشغلون.",
  "No position in this window can be closed without stranding traffic.":
    "لا يمكن إغلاق أي موقع في هذه النافذة دون ترك حركة عالقة.",
  "Absorbed by the rest of the estate": "يستوعبها باقي المرفق",
  "Absorbed, but some passengers are bussed": "مستوعَبة، لكن بعض الركاب يُنقلون بالحافلات",
  "Some aircraft have nowhere to go": "بعض الطائرات لا مكان لها",
  "Not assessed": "لم يُقيَّم",
  "No interval set": "لا فاصل زمني محدد",
  "Entered in the form": "أُدخل في النموذج",
  "Imported from a file": "مستورد من ملف",
  "Sent by another system": "مُرسَل من نظام آخر",
  "Action taken": "إجراء متخذ",
  "Re-test planned": "إعادة اختبار مخطط لها",
  "Work order raised": "صدر أمر عمل",
  Planned: "مخطط",
  Design: "التصميم",
  Tender: "الطرح",
  Construction: "الإنشاء",
  Commissioning: "التشغيل التجريبي",
  "On baseline": "وفق خط الأساس",
  "Ahead of baseline": "متقدم على خط الأساس",
  Slipped: "متأخر",
  "No baseline": "بلا خط أساس",
  "No current date": "بلا تاريخ حالي",
  "No dates": "بلا تواريخ",
  "Not submitted": "لم يُقدَّم",
  "Awaiting decision": "بانتظار القرار",
  Waived: "مُعفى",
  Waive: "إعفاء",
  "Hold point": "نقطة توقف",
  "Witness point": "نقطة شهود",
  Surveillance: "مراقبة",
  "Re-inspection": "إعادة فحص",
  Final: "نهائي",
  "Pass with observations": "ناجح مع ملاحظات",
  Conditional: "مشروط",
  Fail: "راسب",
  "Not applicable": "لا ينطبق",
  "N/A": "لا ينطبق",
  "Not checked": "لم يُفحص",
  "Work stopped": "العمل متوقف",
  "Gates awaiting decision": "بوابات بانتظار القرار",
  "Gates decided without evidence": "بوابات بُتّ فيها دون أدلة",
  "Sheets left incomplete": "أوراق تُركت غير مكتملة",
  "Slipped against baseline": "متأخر عن خط الأساس",
  "Never inspected": "لم يُفحص قط",
  Rebaselined: "أُعيد تحديد خط أساسه",
  "Unreleased hold points. Each stops the work it covers until somebody releases it.":
    "نقاط توقف غير مُفرج عنها. كلٌّ منها يوقف العمل الذي تغطيه حتى يُفرج عنها أحد.",
  "Submitted and waiting on a decision.": "مُقدَّمة وبانتظار قرار.",
  "Decided anyway, with required items never supplied. Recorded for the project's life.":
    "بُتّ فيها رغم عدم تقديم البنود المطلوبة. ومسجَّل طوال عمر المشروع.",
  "A result was recorded while items were still unchecked — work somebody believes is finished.":
    "سُجِّلت نتيجة بينما بنود لا تزال دون فحص — عمل يعتقد أحدهم أنه انتهى.",
  "Live and past the current end date.": "قائم وتجاوز تاريخ النهاية الحالي.",
  "The current end date is later than the baseline.": "تاريخ النهاية الحالي بعد خط الأساس.",
  "Nothing can be late against no baseline, so these never appear above however far they run.":
    "لا شيء يتأخر عن خط أساس غير موجود، لذا لا تظهر هذه أعلاه مهما طالت.",
  "In construction or commissioning with no inspection recorded at all.":
    "في الإنشاء أو التشغيل التجريبي دون أي فحص مسجَّل إطلاقًا.",
  "The baseline has been moved. Slip is measured against the current one.":
    "نُقل خط الأساس. ويُقاس التأخر على الخط الحالي.",
  "Progress update": "تحديث التقدم",
  Pending: "قيد الانتظار",
  "This project has been rebaselined {n} time. Slip will be measured against the new baseline; the old one stays on the record.|This project has been rebaselined {n} times. Slip will be measured against the new baseline; the old one stays on the record.":
    "لم يُعَد تحديد خط أساس هذا المشروع. سيُقاس التأخر على خط الأساس الجديد؛ ويبقى القديم في السجل.|أُعيد تحديد خط أساس هذا المشروع مرة واحدة. سيُقاس التأخر على خط الأساس الجديد؛ ويبقى القديم في السجل.|أُعيد تحديد خط أساس هذا المشروع مرتين. سيُقاس التأخر على خط الأساس الجديد؛ ويبقى القديم في السجل.|أُعيد تحديد خط أساس هذا المشروع {n} مرات. سيُقاس التأخر على خط الأساس الجديد؛ ويبقى القديم في السجل.|أُعيد تحديد خط أساس هذا المشروع {n} مرة. سيُقاس التأخر على خط الأساس الجديد؛ ويبقى القديم في السجل.|أُعيد تحديد خط أساس هذا المشروع {n} مرة. سيُقاس التأخر على خط الأساس الجديد؛ ويبقى القديم في السجل.",
  "the baseline has been moved {n} time; slip is measured against the current one|the baseline has been moved {n} times; slip is measured against the current one":
    "لم يُنقل خط الأساس؛ ويُقاس التأخر على الخط الحالي|نُقل خط الأساس مرة واحدة؛ ويُقاس التأخر على الخط الحالي|نُقل خط الأساس مرتين؛ ويُقاس التأخر على الخط الحالي|نُقل خط الأساس {n} مرات؛ ويُقاس التأخر على الخط الحالي|نُقل خط الأساس {n} مرة؛ ويُقاس التأخر على الخط الحالي|نُقل خط الأساس {n} مرة؛ ويُقاس التأخر على الخط الحالي",
};
export default ar;
